import React from "react";

const TooltipSelect = ({ id, label, value, onChange, options, suffix = "" }) => {
    return (
        <div className="input-container">
            <select
                id={id}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onFocus={(e) => e.target.nextSibling.classList.add("visible")}
                onBlur={(e) => e.target.nextSibling.classList.remove("visible")}
            >
                {options.map((opt) => (
                    <option key={opt} value={opt}>
                        {opt + suffix}
                    </option>
                ))}
            </select>
            <span className="tooltip">{label}</span>
        </div>
    );
};

export default TooltipSelect;
